import { IsNotEmpty, IsString } from 'class-validator';

export class AbortMctFirmwareUpdateDto
{
    @IsString()
    @IsNotEmpty()
    receiverId!: string;
}